'use client';
import { settingsMenuData } from '@/app/settings/data';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { buttonVariants } from '@/components/ui/button';
import { useMenu } from '@/hooks/useMenu';
import { cn } from '@/lib/cn';
import { Urls } from '@/lib/urls';
import Link from 'next/link';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../../ui/accordion';
import { SubMenuSettings } from './sub-menu-settings';
import { useSession } from '@/providers/session-provider';

export default function SettingsNavigation() {
  const notifications = {};

  const { sidebarSettings, setSidebarSettings } = useMenu();

  const {
    data: { user },
  } = useSession();

  return (
    <>
      <div className='mt-4 flex w-full items-center gap-4 px-4'>
        <div className='flex w-full items-center gap-3 border-b pb-4'>
          <Avatar className='size-8'>
            <AvatarImage
              width={32}
              height={32}
              src={user?.profilePicture?.get}
              alt={user?.communicationName}
            />
            <AvatarFallback>
              {user?.firstName?.[0] ?? 'A'}
              {user?.lastName?.[0] ?? 'N'}
            </AvatarFallback>
          </Avatar>
          <Link
            prefetch={false}
            className={cn(
              buttonVariants({ variant: 'link' }),
              'p-0 text-base text-foreground'
            )}
            href={Urls.settings.profile.settings}
          >
            {user?.communicationName || 'Användare'}
          </Link>
        </div>
      </div>
      <Accordion
        className='scrollbar-hide space-y-4 overflow-y-scroll p-4 pt-0'
        type='multiple'
        defaultValue={[
          'admin',
          'security',
          'globalConfiguration',
          'organizationsettings',
          'modulesettings',
        ]}
        value={sidebarSettings.expandedItems?.['settings_root']}
        onValueChange={(values) =>
          setSidebarSettings((prev) => ({
            ...prev,
            expandedItems: {
              ...prev.expandedItems,
              settings_root: values,
            },
          }))
        }
      >
        {Object.values(settingsMenuData).map((value) => {
          return (
            <AccordionItem
              className='w-full border-none'
              value={value.key}
              key={value.key}
            >
              <div
                className={cn(
                  'mt-2 flex w-full items-center rounded py-2 pr-2 text-left text-sm text-secondary-foreground transition-colors hover:bg-accent'
                )}
              >
                <AccordionTrigger
                  className={cn(
                    'p-0 text-left text-foreground/90 hover:no-underline [&>svg]:opacity-0 [&>svg]:transition-all hover:[&>svg]:opacity-100'
                  )}
                >
                  <span className='w-full pl-2 text-xs font-normal'>
                    {value.title}
                  </span>
                </AccordionTrigger>
              </div>

              <AccordionContent>
                {value.subMenus
                  .filter((menu) => !menu.hidden)
                  .map((menu) => (
                    <SubMenuSettings
                      menu={menu}
                      notifications={notifications}
                      key={menu.key}
                    />
                  ))}
              </AccordionContent>
            </AccordionItem>
          );
        })}
      </Accordion>
    </>
  );
}
